import {invert} from 'underscore';

export enum ChemistryReactionRole {
  REACTANT = 'REACTANT',
  PRODUCT = 'PRODUCT',
  CATALYST = 'CATALYST',
  SOLVENT = 'SOLVENT',
  BYPRODUCT = 'BYPRODUCT',
}

export const CHEMISTRY_REACTION_ROLE_TO_DISPLAY_NAME: Record<ChemistryReactionRole, string> = {
  [ChemistryReactionRole.REACTANT]: 'Reactant',
  [ChemistryReactionRole.PRODUCT]: 'Product',
  [ChemistryReactionRole.CATALYST]: 'Catalyst',
  [ChemistryReactionRole.SOLVENT]: 'Solvent',
  [ChemistryReactionRole.BYPRODUCT]: 'Byproduct',
};

export const CHEMISTRY_REACTION_ROLE_DISPLAY_NAME_TO_ENUM: Partial<Record<string, ChemistryReactionRole>> =
  invert(CHEMISTRY_REACTION_ROLE_TO_DISPLAY_NAME);

// This is somewhat arbitrary; mainly reactant should come before product.
export const CHEMISTRY_REACTION_ROLE_TO_SORT_ORDER: Record<ChemistryReactionRole, number> = {
  [ChemistryReactionRole.REACTANT]: 0,
  [ChemistryReactionRole.PRODUCT]: 1,
  [ChemistryReactionRole.CATALYST]: 2,
  [ChemistryReactionRole.SOLVENT]: 3,
  [ChemistryReactionRole.BYPRODUCT]: 4,
};
